<template>
  <div v-loading="loading">
    <el-tabs v-model="activeName">
      <!-- Boiler Pressure -->
      <el-tab-pane label="Boiler" name="boiler">
        <div style="margin-left: 300px">
          <h2>Boiler Pressure: {{ boilerForm.currentPressure }}</h2>
        </div>
        <el-form ref="form" :model="boilerForm" label-width="250px" @submit.prevent="onSubmit" style="margin: 20px; width: 60%; min-width: 600px">
          <el-form-item label="Enabled">
            <el-checkbox v-model="boilerForm.enabled"></el-checkbox>
          </el-form-item>
          <el-form-item label="Calibration Adjustment" v-show="boilerForm.enabled">
            <el-input v-model="boilerForm.calibrationAdjustment"></el-input>
          </el-form-item>
          <el-form-item label="Range High (20mA)" v-show="boilerForm.enabled">
            <el-input v-model="boilerForm.rangeHigh"></el-input>
          </el-form-item>
          <el-form-item label="Range Low (4mA)" v-show="boilerForm.enabled">
            <el-input v-model="boilerForm.rangeLow"></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 10px">
            <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Supply" name="supply">
        <div style="margin-left: 300px">
          <h2>Supply Pressure: {{ supplyForm.currentPressure }}</h2>
        </div>
        <el-form ref="form" :model="supplyForm" label-width="250px" @submit.prevent="onSubmit" style="margin: 20px; width: 60%; min-width: 600px">
          <el-form-item label="Enabled">
            <el-checkbox v-model="supplyForm.enabled" :disabled="supplyForm.allowControlEnabled"></el-checkbox>
          </el-form-item>
          <el-form-item label="Calibration Adjustment" v-show="supplyForm.enabled">
            <el-input v-model="supplyForm.calibrationAdjustment"></el-input>
          </el-form-item>
          <el-form-item label="Range High (20mA)" v-show="supplyForm.enabled">
            <el-input v-model="supplyForm.rangeHigh"></el-input>
          </el-form-item>
          <el-form-item label="Range Low (4mA)" v-show="supplyForm.enabled">
            <el-input v-model="supplyForm.rangeLow"></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 10px">
            <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Return" name="return">
        <div style="margin-left: 300px">
          <h2>Return Pressure: {{ returnForm.currentPressure }}</h2>
        </div>
        <el-form ref="form" :model="returnForm" label-width="250px" @submit.prevent="onSubmit" style="margin: 20px; width: 60%; min-width: 600px">
          <el-form-item label="Enabled">
            <el-checkbox v-model="returnForm.enabled" :disabled="returnForm.allowControlEnabled"></el-checkbox>
          </el-form-item>
          <el-form-item label="Calibration Adjustment" v-show="returnForm.enabled">
            <el-input v-model="returnForm.calibrationAdjustment"></el-input>
          </el-form-item>
          <el-form-item label="Range High (20mA)" v-show="returnForm.enabled">
            <el-input v-model="returnForm.rangeHigh"></el-input>
          </el-form-item>
          <el-form-item label="Range Low (4mA)" v-show="returnForm.enabled">
            <el-input v-model="returnForm.rangeLow"></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 10px">
            <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Axios from "axios"
import echarts from "echarts"
import SettingsService from "@/api/settings.service"
import IOService from "@/api/io.service"
import constants from "@/common/constants/system"
import Util from "@/common/js/util"

export default {
  data() {
    return {
      loading: false,
      polling: null,
      user: this.$session.get("User"),
      activeName: "boiler",
      boilerForm: {
        currentPressure: "",
        enabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      supplyForm: {
        currentPressure: "",
        enabled: false,
        allowControlEnabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      returnForm: {
        currentPressure: "",
        enabled: false,
        allowControlEnabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      }
    }
  },
  mounted() {
    this.getData()
    this.getIOData()
    this.polling = setInterval(this.getIOData, 1000)
  },
  beforeDestroy() {
    clearInterval(this.polling)
  },
  methods: {
    verifySettings() {
      if (isNaN(parseInt(this.boilerForm.calibrationAdjustment)) || isNaN(parseInt(this.boilerForm.rangeHigh)) || isNaN(parseInt(this.boilerForm.rangeLow))) {
        this.notify("Boiler Pressure")
        return false
      }
      if (isNaN(parseInt(this.supplyForm.calibrationAdjustment)) || isNaN(parseInt(this.supplyForm.rangeHigh)) || isNaN(parseInt(this.supplyForm.rangeLow))) {
        this.notify("Boiler Pressure")
        return false
      }
      if (isNaN(parseInt(this.returnForm.calibrationAdjustment)) || isNaN(parseInt(this.returnForm.rangeHigh)) || isNaN(parseInt(this.returnForm.rangeLow))) {
        this.notify("Boiler Pressure")
        return false
      }
      return true
    },
    saveDataToPanel() {
      if (!this.verifySettings()) return
      switch (this.activeName) {
        case "boiler":
          this.loading = true
          Axios.all([
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Boiler.Enabled", this.boilerForm.enabled ? "true" : "false"),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Boiler.CalibrationAdjustment", this.boilerForm.calibrationAdjustment),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Boiler.RangeHigh", this.boilerForm.rangeHigh),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Boiler.RangeLow", this.boilerForm.rangeLow)
          ])
            .then(
              Axios.spread((enabledResponse, calibrationResponse, rangeHighResponse, rangeLowResponse) => {
                //The system should update in 10 seconds.
                this.loading = false
                if (
                  enabledResponse.data.result != "success" ||
                  calibrationResponse.data.result != "success" ||
                  rangeHighResponse.data.result != "success" ||
                  rangeLowResponse.data.result != "success"
                ) {
                  const h = this.$createElement
                  this.$notify({
                    title: "Boiler Pressure Sensor Settings",
                    message: "Error trying to save data to panel",
                    type: "error"
                  })
                } else {
                  this.$notify({
                    title: "Boiler Pressure Sensor Settings",
                    message: "Settings Saved to Panel",
                    type: "info"
                  })
                }
              })
            )
            .catch(() => {
              this.loading = false
              const h = this.$createElement
              this.$notify({
                title: "Boiler Pressure Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              })
            })
          break
        case "supply":
          this.loading = true
          Axios.all([
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Supply.Enabled", this.supplyForm.enabled ? "true" : "false"),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Supply.CalibrationAdjustment", this.supplyForm.calibrationAdjustment),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Supply.RangeHigh", this.supplyForm.rangeHigh),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Supply.RangeLow", this.supplyForm.rangeLow)
          ])
            .then(
              Axios.spread((enabledResponse, calibrationResponse, rangeHighResponse, rangeLowResponse) => {
                //The system should update in 10 seconds.
                this.loading = false
                if (
                  enabledResponse.data.result != "success" ||
                  calibrationResponse.data.result != "success" ||
                  rangeHighResponse.data.result != "success" ||
                  rangeLowResponse.data.result != "success"
                ) {
                  const h = this.$createElement
                  this.$notify({
                    title: "Supply Pressure Sensor Settings",
                    message: "Error trying to save data to panel",
                    type: "error"
                  })
                } else {
                  this.$notify({
                    title: "Supply Pressure Sensor Settings",
                    message: "Settings Saved to Panel",
                    type: "info"
                  })
                }
              })
            )
            .catch(() => {
              this.loading = false
              const h = this.$createElement
              this.$notify({
                title: "Supply Pressure Sensor Settings",
                message: "Error trying to save data to Supply",
                type: "error"
              })
            })
          break
        case "return":
          this.loading = true
          Axios.all([
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Return.Enabled", this.returnForm.enabled ? "true" : "false"),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Return.CalibrationAdjustment", this.returnForm.calibrationAdjustment),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Return.RangeHigh", this.returnForm.rangeHigh),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Pressure.Return.RangeLow", this.returnForm.rangeLow)
          ])
            .then(
              Axios.spread((enabledResponse, calibrationResponse, rangeHighResponse, rangeLowResponse) => {
                //The system should update in 10 seconds.
                this.loading = false
                if (
                  enabledResponse.data.result != "success" ||
                  calibrationResponse.data.result != "success" ||
                  rangeHighResponse.data.result != "success" ||
                  rangeLowResponse.data.result != "success"
                ) {
                  const h = this.$createElement
                  this.$notify({
                    title: "Return Pressure Sensor Settings",
                    message: "Error trying to save data to panel",
                    type: "error"
                  })
                } else {
                  this.$notify({
                    title: "Return Pressure Sensor Settings",
                    message: "Settings Saved to Panel",
                    type: "info"
                  })
                }
              })
            )
            .catch(() => {
              this.loading = false
              const h = this.$createElement
              this.$notify({
                title: "Return Pressure Sensor Settings",
                message: "Error trying to save data to Supply",
                type: "error"
              })
            })
          break
      }
    },
    getData() {
      //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
      Axios.all([IOService.getSettings(this.user.activeZone)]).then(
        Axios.spread((settingsResponse) => {
          //Boiler Pressure
          this.boilerForm.enabled = settingsResponse.data.sensors.pressure.boiler.enabled == "true"
          this.boilerForm.calibrationAdjustment = settingsResponse.data.sensors.pressure.boiler.calibrationAdjustment
          this.boilerForm.rangeHigh = settingsResponse.data.sensors.pressure.boiler.rangeHigh
          this.boilerForm.rangeLow = settingsResponse.data.sensors.pressure.boiler.rangeLow
          //Supply Pressure
          this.supplyForm.enabled = settingsResponse.data.sensors.pressure.supply.enabled == "true"
          this.supplyForm.calibrationAdjustment = settingsResponse.data.sensors.pressure.supply.calibrationAdjustment
          this.supplyForm.rangeHigh = settingsResponse.data.sensors.pressure.supply.rangeHigh
          this.supplyForm.rangeLow = settingsResponse.data.sensors.pressure.supply.rangeLow
          //Return Pressure
          this.returnForm.enabled = settingsResponse.data.sensors.pressure.return.enabled == "true"
          this.returnForm.calibrationAdjustment = settingsResponse.data.sensors.pressure.return.calibrationAdjustment
          this.returnForm.rangeHigh = settingsResponse.data.sensors.pressure.return.rangeHigh
          this.returnForm.rangeLow = settingsResponse.data.sensors.pressure.return.rangeLow
          //Supply and Return enabled if differential switch is on
          //We check if we can allow the user to enabled or disable
          if (settingsResponse.data.differential.enabled == "true") {
            this.supplyForm.allowControlEnabled = true
            this.returnForm.allowControlEnabled = true
          }
        })
      )
    },
    getIOData() {
      //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
      Axios.all([IOService.getIO(this.user.activeZone)]).then(
        Axios.spread((IOResponse) => {
          this.boilerForm.currentPressure = Util.printPressure(IOResponse.data.sensors.pressure.boiler)
          this.supplyForm.currentPressure = Util.printPressure(IOResponse.data.sensors.pressure.supply)
          this.returnForm.currentPressure = Util.printPressure(IOResponse.data.sensors.pressure.return)
        })
      )
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  float: left;
}
/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
  padding: 30px 20px;
}
</style>



// WEBPACK FOOTER //
// PressureSensors.vue?d0755f10